import { InputLeftElement, InputRightElement, Spinner } from '@chakra-ui/react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import SearchIcon from 'src/assets/icons/SearchIcon';
import TextInput from './TextInput';

export interface SearchInputProps extends ComponentPropsWithoutRef<typeof TextInput> {
  isLoading?: boolean;
}

/**
 * For use outside of a form. This component does not need to be wrapped in a `FormControl` component.
 * Use the `isLoading` prop to show a loading spinner.
 */
const SearchInput = forwardRef<any, SearchInputProps>(({ isLoading, ...props }, ref) => {
  return (
    <TextInput
      inputGroupProps={{ gridGap: '10px' }}
      placeholder="Search"
      _focus={{ pl: '48px' }}
      ref={ref}
      {...props}
    >
      <InputLeftElement>
        <SearchIcon />
      </InputLeftElement>
      {isLoading && (
        <InputRightElement>
          <Spinner
            thickness="4px"
            speed="0.65s"
            color="podcastPurple"
            size="md"
            alignSelf="center"
          />
        </InputRightElement>
      )}
    </TextInput>
  );
});

export default SearchInput;
